import { formatMoney, getMessage } from "../i18n/locale";

export function getStudioRateDisplay(studio, locale = "en-ZA") {
  const currency = studio?.currency || "ZAR";
  const rateCards = Array.isArray(studio?.rateCards) ? studio.rateCards : [];
  const validRates = rateCards
    .filter((rate) => rate?.price !== null && rate?.price !== undefined && rate?.price !== "")
    .map((rate) => ({ ...rate, numericPrice: Number(rate.price) }))
    .filter((rate) => Number.isFinite(rate.numericPrice));
  const lowestRate = validRates.reduce(
    (lowest, rate) => (!lowest || rate.numericPrice < lowest.numericPrice ? rate : lowest),
    null
  );

  if (lowestRate) {
    const price = formatMoney(lowestRate.numericPrice, { locale, currency });
    return lowestRate.label ? `${price} • ${lowestRate.label}` : price;
  }

  const legacyRate = Number(studio?.rateFrom);
  if (Number.isFinite(legacyRate)) {
    return getMessage(locale, "studioRateFromPerHour")
      .replace("{price}", formatMoney(legacyRate, { locale, currency }));
  }

  return getMessage(locale, "studioRateOnRequest");
}
